import React from 'react'
function ErrorPage() {
  return (
    <div className={'d-flex justify-content-center'} style={styles.container}>
      <h1>Whoa! Gnarly!</h1>
      <p>
        Looks like something is messed up and the page failed to load… Please try and refresh the
        page to continue your session.
      </p>
      <p>
        If the problem persists here are few steps to take:
        <ul>
          <li>Check your browser settings.</li>
          <li>Try using an Incognito/Private browser.</li>
          <li>Clear the cache stored on your browser. (Ctl + R or F4)</li>
        </ul>
      </p>
      <p>
        Reminder:
        <ul>
          <li>We always recommend that you use a Chrome browser when using BLAZE</li>
        </ul>
      </p>
    </div>
  )
}

const styles = {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '16px',
  },
}

export default ErrorPage



// WEBPACK FOOTER //
// ./src/components/common/ErrorPage.js